import { https , httpsFile } from './http.js';

export function index () {
    return httpsFile().get(`companies`);
}

export function show (company) {
    return httpsFile().get(`companies/${company}`);
}
export function getAssignedCompanyAddress () {
    return httpsFile().get(`getAssignedCompanyAddress`);
}